var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.449,
    height: 16.449,
    viewBox: "0 0 16.449 16.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.111 1.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 14,
    height: 14,
    transform: "translate(0.113 0.113)",
    fill: "#707070",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b72cbd71-5282-400f-897b-b7738907a4ea",
    d: "M6.323-1.111A7.434,7.434,0,1,1-1.111,6.323,7.442,7.442,0,0,1,6.323-1.111Zm0,12.646A5.212,5.212,0,1,0,1.111,6.323,5.218,5.218,0,0,0,6.323,11.535Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_0f4e64a0-644e-4103-a76c-1c734be10aef",
    "data-name": "0f4e64a0-644e-4103-a76c-1c734be10aef",
    d: "M3.438,4.549a1.108,1.108,0,0,1-.786-.325L-.786.786a1.111,1.111,0,0,1,0-1.571,1.111,1.111,0,0,1,1.571,0L4.224,2.652a1.111,1.111,0,0,1-.786,1.9Z",
    transform: "translate(10.788 10.788)",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFinder);
export default __webpack_public_path__ + "static/media/ic_finder.90ff5a3bdd7693a0fbc0682049423ac3.svg";
export { ForwardRef as ReactComponent };